/**
 * Shared numeric input ranges (start = min, end = max) reused across forms that
 * clamp the same values. Keeps min/max in one place instead of magic numbers.
 */
export const MIN_MAX = {
    ACCESS_TOLERANCE: { start: 0, end: 60 },
    RESEND_INVITATION_HOUR: { start: 1, end: 168 },
};
